import React from "react";
import { Col, Container, Row } from "reactstrap";
import 'swiper/css/pagination';
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { testimonialData } from "../Data/ComponentsData/componentsdata";

const Testimonial = () => { 
  const options = {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    pagination: {
      clickable: true,
    },
    breakpoints: {
      600: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      991: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  };

  return (
    <section className='testimonial' id='testimonial'>
      <div className='animation-circle-inverse'>
        <i></i>
        <i></i>
        <i></i>
      </div>
      <Container>
        <Row>
          <Col md={12}>
            <div className='testimonil-box'>
              <Swiper className='testimonial-slider' {...options} modules={[Pagination]}>
                {testimonialData.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className='item testi-profile'>
                      <div className='media'>
                        <div className='animated-circle'>
                          <img src={`assets/images/${item.photo}`} alt='Testimonial' className='img-fluid align-self-center' />
                        </div>
                        <div className='media-body'>
                          <h3 className='mt-0 sub-title'>{item.name}</h3>
                          <p>{item.description}</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Testimonial;
